import React from 'react';
import { translations } from 'src/constants/translations';
import AddIcon from '@mui/icons-material/Add';
import {
  LocationButtonsEnum,
} from 'src/components/profileComponents/Marketplace/components/Filters/constants';
import { MarketplaceButton } from 'src/components/profileComponents/Marketplace/components/Common/MarketplaceButton';
import Box from '@mui/material/Box';

interface ILocationButtonsProps {
  onClick?: (type: LocationButtonsEnum) => void
}

export const LocationButtons: React.FC<ILocationButtonsProps> = ({ onClick }) => {
  return (
    <Box display="flex" gap="16px">
      <MarketplaceButton
        startIcon={<AddIcon />}
        label={translations.locationGroup}
        onClick={() => onClick && onClick(LocationButtonsEnum.locationGroup)}
      />
      <MarketplaceButton
        startIcon={<AddIcon />}
        label={translations.elementsList}
        onClick={() => onClick && onClick(LocationButtonsEnum.elementsList)}
      />
    </Box>
  );
};
